import { FORM_VALUE_INTER } from './constant';

export const convert = (data: FORM_VALUE_INTER) => ({
  ...data,
  lang: Array.isArray(data.lang) ? data.lang[0].value : null,
});
